export default __webpack_public_path__ + "static/media/MyCoachLock.a97954af.png";